/** The inspector panel's how-to line, shared by every surface so the keys read the same everywhere. */
export const INSPECTOR_KEYS_HINT =
  'Hover a dashed string to see its id and the English original. While hovering, press I to copy the id or T to copy the text. Press E to switch the page to English and back.';
